import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src391911660/src/CVCircuit/frontend/app/blog/[slug]/BlogPostPageClient.tsx");
